module.exports = __webpack_public_path__ + "static/media/price.bd26699e.svg";